import { SB } from '@play-co/replicant';
import { tuple } from '../utils/types';

export const socialSchema = {
  /**
   * @deprecated Visit availability comes from the Replicant Presence API (#11159).
   * Nothing reads or writes this flag; delete it with a state migration.
   */
  isOnline: SB.boolean(),

  social: SB.object({
    invites: SB.map(
      SB.object({
        timeSent: SB.number(),
        referralRewardClaimed: SB.boolean(),
      }),
    ),
    challenge: SB.object({
      startTime: SB.int(),
      counter: SB.int(),
      claimed: SB.boolean(),
      claimedWallpapers: SB.array(SB.string()),
      resetTimes: SB.int(),
    }),

    referral: SB.object({
      // Join referral flow was processed, all referral reward was sent
      joinCompleteAt: SB.int().default(0),

      // Current player was invited by this user ID
      invitedBy: SB.string().optional(),

      // Pending referral rewards
      pendingRewards: SB.array(
        SB.object({
          // User joined to game
          friendId: SB.string(),
          // Reward details
          reward: SB.object({
            type: SB.tuple(tuple('gems')),
            value: SB.int(),
          }),
          // When reward was created
          createdAt: SB.int(),
        }),
      ),

      // List of referred friends.
      referred: SB.map(
        SB.object({
          createdAt: SB.int(),
        }),
      ),

      // Latest referred friend to become visitable.
      visitableFriend: SB.object({
        friendId: SB.string(),
        name: SB.string(),
        photo: SB.string(),
        frame: SB.string(),
        createdAt: SB.int(),
      }).optional(),
    }),

    // User share link cache
    shareLink: SB.object({
      id: SB.string(),
      createdAt: SB.int(),
      hash: SB.string(),
    }).optional(),
  }),
};
